<template>
  <div :class="['loading', {}, props.className]" :style="[props.inlineStyles]">
    <div v-if="props.isPulse || props.isCircleFade || props.isFlow || props.isWave" class="loader"></div>
  </div>
</template>

<script setup>
const props = defineProps({
  className: {
    type: String,
  },
  inlineStyles: {
    type: Object,
    default: function () {
      return {};
    },
  },
  isPulse: {
    type: Boolean,
  },
  isCircleFade: {
    type: Boolean,
  },
  isFlow: {
    type: Boolean,
  },
  isWave: {
    type: Boolean,
  },
  sizePulse: {
    type: Number,
    default: 28,
  },
});
</script>

<style lang="scss">
.loading {
  display: inline-block;

  .loader {
    width: $specific-overlay-size-loader;
    height: $specific-overlay-size-loader;
    top: 428px;
    left: 698px;
    gap: 0px;
    border: 2px 0px 0px 0px;
     
    border: 2px solid $specific-overlay-foreground-loader;
    border-top: 5px solid #fff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
